module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAAA8BAMAAACA4dvBAAAAGFBMVEVHcEzlpm3lpm3lpm3lpW3lpm3lpm3lpm3lfrO4AAAAB3RSTlMA35dtIbxG8ia5ugAAAOxJREFUWMPt2MEKgkAUheFTWOuMBveae1GybZDYWkPaFkr7sWJevwhamBI66XVz/xf4OF4IGgAbS9Elj3h1UbStgLmi7owJubnAlty84URulrDITQlFH5tssskmm2yyySabbLLJJptskphj/M+mf094jPJuciA375iSmx7ID1oCmNHPpH7YXOPdPiETlx4+Rbk9vCvTMEI1I/eTAb2gQHNG7Lu9/xgKu7avVo8fWqZOsUPLjOvfg9vMqxfrDu40r+nCgWt24TJHZ57ul5bCCQv0WpT7mfXjeD1zlRN/wVLYwWBcZbGbmMoUqd7tnl67SmGMMr8aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/lesson-long.png
// module id = 615
// module chunks = 1